'use strict';

const _ = require('underscore');
const Comment = require('communication/domain/entity/comment');
const ReadMore = require('framework/domain/value/readmore');
const Pagination = require('framework/domain/value/pagination');
const ReadMoreCollection = require('framework/domain/collection/readmore-collection');

module.exports = class CommentCollection extends ReadMoreCollection {
    constructor(models, options) {
        super(models, options);

        this._key = options.key;
        this._repository = options.repository;

        this.listenTo(this, 'active', this.activateOnlyOne);
        this.listenTo(this, 'active:reply', this.activateOnlyOne);
        this.listenTo(this._repository, 'add', comment => {
            if(this.isBelongToSomePage(comment)) {
                this.add(comment);
            }
        });
        this.listenTo(this._repository, 'add:count', comment => {
            if(this.isBelongToCollection(comment)) {
                this.addTotalCount(1);
            }
        });
    }

    model2number(model) {
        return - model.getUpdatedAt().unix();
    }

    isBelongToCollection(model) {
        return model.isRelatedTo(this._key) &&
            // 返信コメントは追加しない
            !model.getReplyTo();
    }

    fetch(limit, cursor, isAsc=true) {
        const options = {direction: isAsc ? "next" : "prev"};
        return this._repository.fetchByKey(this._key, limit, cursor, options)
            .then(result => {
                const pagination = result.pagination;
                return {
                    models: result.models,
                    pagination: new Pagination(
                        pagination.totalCount,
                        pagination.prevCursor,
                        pagination.prevMore,
                        pagination.nextCursor,
                        pagination.nextMore
                    )
                }
            });
    }

    fetchPageByCommentID(commentID, limit=3) {
        return this._repository.fetchByKeyAndCommentID(this._key, commentID, limit)
            .then(result => {
                const pagination = result.pagination;
                return {
                    models: result.models,
                    pagination: new Pagination(
                        pagination.totalCount,
                        pagination.prevCursor,
                        pagination.prevMore,
                        pagination.nextCursor,
                        pagination.nextMore
                    )
                }
            })
            .then(result => {
                this.add(result.models, {merge: true});
                this._totalCount = result.pagination.totalCount;

                const page = this.buildPage(result.models, result.pagination, true);
                this._addPage(page);
                this.add(page.getReadMores());

                return this;
            });
    }

    activateOnlyOne(model) {
        this.each(m => {
            if(m instanceof ReadMore) {
                return;
            }

            if(m.isActive() && m.id != model.id) {
                m.deactivate();
            }
            _.each(m.getActiveReplyComments(), c => {
                if(c.id != model.id) {
                    c.deactivate();
                }
            });
        });
    }

    getCommentsHasElementId(elementID) {
        return this.filter(function(comment) {
            return _.find(
                _.map(comment.filterRelatedKeysByKind('Element'), k => k[1]),
                id => id.indexOf(elementID) > 0);
        });
    }

    getCommentByID(commentID) {
        const comment = this.find(comment => {
            if(comment instanceof ReadMore) {
                return false;
            }
            return comment.id == commentID ||
                comment.getReplyComments().get(commentID);
        });

        if(!comment) {
            return null;
        }

        if(comment.id == commentID) {
            return comment;
        }

        return comment.getReplyComments().get(commentID);
    }

    getOrFetchCommentByID(commentID) {
        let comment = this.getCommentByID(commentID);
        if (comment) {
            return new Promise(resolve => {
                resolve(comment);
            });
        }

        return new Promise((resolve, reject) => {
            this.fetchPageByCommentID(commentID)
                .then(() => {
                    resolve(this.getCommentByID(commentID));
                })
                .catch(reject);
        });
    }
};



// WEBPACK FOOTER //
// ./communication/domain/collection/comment.js